import { ReactNode } from 'react';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import rehypeSanitize from 'rehype-sanitize';
import remarkGfm from 'remark-gfm';

interface CommentBodyProps {
  markdown: string;
}

export const CommentBody = ({ markdown }: CommentBodyProps): ReactNode => (
  <div className='activity-feed-detail-comment-body markdown-body'>
    {/* rehype-sanitize after rehype-raw so inline HTML is stripped before render */}
    <ReactMarkdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw, rehypeSanitize]}>
      {markdown}
    </ReactMarkdown>
  </div>
);
